const CONTENT_SELECTOR = '.rich-text-content';
const IMAGE_SELECTOR = `${CONTENT_SELECTOR} img`;
const EDITOR_SELECTOR = '[data-component="textarea-editor"]';

let gallerySequence = 0;

function isInsideEditor(element) {
    return Boolean(element?.closest?.(EDITOR_SELECTOR));
}

function normalizeUrl(url) {
    if (!url) {
        return '';
    }

    try {
        return new URL(url, window.location.href).href;
    } catch (_error) {
        return url;
    }
}

function ensureGalleryId(container) {
    if (!container) {
        return 'rich-text-gallery';
    }

    let galleryId = container.getAttribute('data-fancybox-gallery');
    if (galleryId) {
        return galleryId;
    }

    gallerySequence += 1;
    galleryId = `rich-text-gallery-${gallerySequence}`;
    container.setAttribute('data-fancybox-gallery', galleryId);

    return galleryId;
}

function getDirectImageLink(imageElement) {
    const parent = imageElement?.parentElement;

    if (!parent || parent.tagName !== 'A') {
        return null;
    }

    return parent;
}

function ensureImageLink(imageElement) {
    const imageSrc = imageElement.currentSrc || imageElement.getAttribute('src') || '';
    if (!imageSrc) {
        return null;
    }

    const existingLink = getDirectImageLink(imageElement);
    if (existingLink) {
        const href = existingLink.getAttribute('href');
        if (href && normalizeUrl(href) !== normalizeUrl(imageSrc)) {
            return null;
        }

        if (!href) {
            existingLink.setAttribute('href', imageSrc);
        }

        return existingLink;
    }

    const link = document.createElement('a');
    link.setAttribute('href', imageSrc);
    link.classList.add('disable-ajax');
    imageElement.parentNode?.insertBefore(link, imageElement);
    link.appendChild(imageElement);

    return link;
}

function getImageCaption(imageElement) {
    const caption = imageElement.getAttribute('data-fancybox-caption')
        || imageElement.getAttribute('alt')
        || imageElement.getAttribute('title')
        || '';
    const holder = document.createElement('div');
    holder.textContent = caption;

    return holder.innerHTML;
}

function bindFancybox(anchors) {
    const $ = window.jQuery || window.$;
    if (!$ || !anchors.length) {
        return;
    }
    if (!$.fn.fancybox) {
        import('../vendor/jquery.fancybox.min.js').then(() => bindFancybox(anchors));
        return;
    }

    const unboundAnchors = anchors.filter((anchor) => anchor.getAttribute('data-fancybox-bound') !== 'true');
    if (!unboundAnchors.length) {
        return;
    }

    $(unboundAnchors).fancybox({
        hash: false,
    });
    unboundAnchors.forEach((anchor) => {
        anchor.setAttribute('data-fancybox-bound', 'true');
    });
}

function prepareImage(imageElement) {
    if (!imageElement || isInsideEditor(imageElement)) {
        return null;
    }

    if (imageElement.getAttribute('data-fancybox-processed') === 'true') {
        return getDirectImageLink(imageElement);
    }

    const container = imageElement.closest(CONTENT_SELECTOR);
    if (!container) {
        return null;
    }

    const link = ensureImageLink(imageElement);
    if (!link) {
        imageElement.setAttribute('data-fancybox-processed', 'true');
        return null;
    }

    link.classList.add('disable-ajax');
    link.setAttribute('data-fancybox', ensureGalleryId(container));
    link.setAttribute('data-type', 'image');

    const caption = getImageCaption(imageElement);
    if (caption) {
        link.setAttribute('data-caption', caption);
    } else {
        link.removeAttribute('data-caption');
    }

    imageElement.setAttribute('data-fancybox-processed', 'true');
    return link;
}

function initRichTextFancybox(root = document) {
    if (root !== document && isInsideEditor(root)) {
        return;
    }

    const images = [];
    if (root.matches?.(IMAGE_SELECTOR)) {
        images.push(root);
    }

    root.querySelectorAll?.(IMAGE_SELECTOR).forEach((imageElement) => {
        images.push(imageElement);
    });

    const anchors = images
        .map((imageElement) => prepareImage(imageElement))
        .filter(Boolean);

    bindFancybox(anchors);
}

function initFancyboxImages() {
    initRichTextFancybox(document);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE || isInsideEditor(node)) {
                    return;
                }

                initRichTextFancybox(node);
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFancyboxImages, { once: true });
} else {
    initFancyboxImages();
}
